
import { defineComponent, ref, inject, computed, onMounted, provide } from 'vue'
import { useRoute } from 'vue-router';
import { useI18n } from "vue-i18n/index";
//services
import eventService from "@/core/services/EventService"
import masterService from "@/core/services/MasterService";
import { errManager } from "@/core/config/Tools";

//components
import btnBack from "@/components/buttons/btnBack.vue"
import ModalNominal from "@/views/tournaments/Modals/ModalNominal.vue"
import CardFolder from '@/components/cards/CardFolder.vue';

export default defineComponent({
    name: "tournament-sports",
    components: { ModalNominal, btnBack, CardFolder },
    setup() {
        const toBack = ref("")
        const { t } = useI18n();
        const route = useRoute();
        const { id } = route.params
        const evento = inject<any>("evento")
        const loader = ref(false)
        const search = ref('')
        const listSports = ref<any>([])
        const listStatus = ref<any>([])
        const itemSport = ref<any>({})
        const dialogNominal = ref(false)

        //provides shared data
        provide("dialogNominal", dialogNominal)

        const getSports = async () => {
            loader.value = true
            listSports.value.length = 0
            await eventService.postOptions('sports', {idevent:id})
            .then ( (res) => {
                listSports.value = res.data
                loader.value = false
            }).catch ( ({ response }) => {
                loader.value = false
                errManager(response)
            })
        }

        //lista de estados de acreditacion
        const getStatus = async () => {
            await masterService.Details("api", btoa("6"))
            .then( (res) => {
                listStatus.value.length = 0
                listStatus.value = res.data
            }).catch( ({response}) => {
                errManager(response)
            })
        }

        const filteredSports = computed(() => {
            return listSports.value.filter(
                (item) => (item.name && item.name.toLowerCase().includes(search.value.toLowerCase()))
            );
        });

        //open dialog nominal
        const openDialogNominal = (row) => {
            itemSport.value = row
            dialogNominal.value = true
        }

        onMounted(()=>{
            toBack.value = (route.query.backto) ? atob(route.query.backto.toString()) : ''
            getStatus()
            getSports()
        })

        return {
            t,
            id,
            toBack,
            evento,
            loader,
            search,
            listSports,
            listStatus,
            itemSport,
            dialogNominal,
            //events
            getSports,
            filteredSports,
            openDialogNominal
        }

    },
})
